export default __webpack_public_path__ + "static/media/frame-expand.bbf919be.svg";